<template>
  <Panel class="intro-y" :title="$t('text.customerInfoEmergencyContact')">
    <div
      v-for="(contact, index) in customer.emergencyContacts"
      :key="index"
      class="flex flex-col sm:flex-row sm:items-center"
      :class="{ 'mt-5': index > 0 }"
    >
      <div class="mr-auto">
        <div class="text-gray-600">{{ contact.name }}</div>
        <div class="text-gray-600">
          {{ contact.relationshipType ? contact.relationshipType.name : '' }}
        </div>
      </div>
      <div class="font-medium">{{ contact.phone }}</div>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';

export default {
  props: {
    customer: Object,
  },
  components: { Panel },
};
</script>
